import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import tw from 'twin.macro';

import { Loader } from '@components/Loader';
import { Button } from '@components/Button';
import { ExportIcon } from '@icons/ExportIcon';
import { CaretIcon } from '@icons/CaretIcon';
import { useInsightsContext } from '@insights_module/context/InsightsContext';
import { useTranscriptDownload } from '@insights_module/hooks/useTranscriptDownload';

const FlexStart = tw.div`w-full flex items-center justify-start gap-[6px]`;
const FlexBetween = tw(FlexStart)`justify-between`;
const StyledButton = tw(
  Button.Primary
)`w-full flex items-center justify-between py-[10px] px-[12px] h-auto [&_svg]:fill-current [&_svg]:w-4 [&_svg]:h-4 [&_svg]:transition-all [&_svg]:duration-200`;
const DownloadOptionsContainer = tw.div`border border-solid border-gray-3 rounded p-0.5 z-10 shadow-dropdown`;
const DownloadOptionButton = tw.button`flex items-center justify-between w-full text-text-and-icon-muted text-xs text-left p-[6px] pr-4 flex items-center hover:bg-gray-3 rounded-sm`;

export const DownloadTranscriptButton = () => {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState<boolean>(false);
  const { isTranscriptDownloadInProgress, selectedEpisode } = useInsightsContext();
  const { downloadTranscript } = useTranscriptDownload(selectedEpisode);

  const handleDownloadClick = (type: 'vtt' | 'plain_text') => {
    setIsVisible(false);
    downloadTranscript(type);
  };

  return (
    <>
      <StyledButton onClick={() => setIsVisible(!isVisible)}>
        <FlexBetween>
          <FlexStart>
            <ExportIcon />
            {t(
              'insights.episode_details_drawer.episode_details_sidebar.download_transcript.action'
            )}
          </FlexStart>
          {isTranscriptDownloadInProgress ? (
            <Loader size='xs' theme='dark' tw='m-0 border-text-and-icon-invert' />
          ) : (
            <CaretIcon css={[isVisible && tw`rotate-180`]} />
          )}
        </FlexBetween>
      </StyledButton>
      {isVisible && (
        <DownloadOptionsContainer>
          <DownloadOptionButton onClick={() => handleDownloadClick('vtt')}>
            {t('insights.episode_details_drawer.episode_details_sidebar.download_transcript.vtt')}
          </DownloadOptionButton>
          <DownloadOptionButton onClick={() => handleDownloadClick('plain_text')}>
            {t(
              'insights.episode_details_drawer.episode_details_sidebar.download_transcript.plain_text'
            )}
          </DownloadOptionButton>
        </DownloadOptionsContainer>
      )}
    </>
  );
};
